import { usePriceInput } from "@greeter/hooks";
import { extractNumberFromPriceInput } from "@greeter/maskito";
import css from "./PriceInput.module.scss";
import { TextInput } from "@greeter/matter-v2";

type BarePriceInputProps = {
  id?: string;
  value?: number;
  style?: React.CSSProperties;
  className?: string;
  onChange: (amount?: number) => void;
  onBlur?: () => void;
  ["data-testid"]?: string;
};

export function BarePriceInput(props: BarePriceInputProps) {
  const inputRef = usePriceInput();

  return (
    <TextInput
      className={css.BarePriceInput}
      style={props.style}
      ref={inputRef}
      value={`${props.value ? props.value : "-"} kr.`}
      onInput={(ev) => {
        if (ev.currentTarget.value.trim() === "") {
          props.onChange(undefined);
          return;
        } else {
          props.onChange(
            extractNumberFromPriceInput(ev.currentTarget.value.trim())
          );
        }
      }}
      data-testid={props["data-testid"]}
    />
  );
}

export function PriceInput(props: BarePriceInputProps) {
  const inputRef = usePriceInput({
    initialValue: props.value,
    onChange: props.onChange,
  });

  return (
    <TextInput
      id={props.id}
      className={props.className}
      style={props.style}
      inputMode="numeric"
      ref={inputRef}
      onBlur={props.onBlur}
      data-testid={props["data-testid"]}
    />
  );
}
